import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconManualTransmission: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="manual-transmission">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.1 7.928a2.501 2.501 0 1 0-1.2 0v8.145a2.501 2.501 0 1 0 1.2 0V12.6h5.3v3.473a2.501 2.501 0 1 0 1.2 0V12.6h4.9a1.6 1.6 0 0 0 1.6-1.6V7.928a2.501 2.501 0 1 0-1.2 0V11a.4.4 0 0 1-.4.4h-4.9V7.928a2.501 2.501 0 1 0-1.2 0V11.4H6.1V7.928ZM6.8 5.5a1.3 1.3 0 1 1-2.6 0 1.3 1.3 0 0 1 2.6 0Zm0 13a1.3 1.3 0 1 1-2.6 0 1.3 1.3 0 0 1 2.6 0ZM12 6.8a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6Zm1.3 11.7a1.3 1.3 0 1 1-2.6 0 1.3 1.3 0 0 1 2.6 0Zm5.2-11.7a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6Z"
    />
  </Icon>
);
